var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"items":_vm.breadcrumbItems,"hasBreadcrumb":"","hasBackButton":""}}),_c('form',[_c('b-card',{staticClass:"mc-card__setting"},[_c('b-tabs',{attrs:{"content-class":"p-3 text-muted","nav-wrapper-class":"mc-tab"}},[(
            _vm.hasAccessAll([
              'c4b-setumum-industrikategori:read',
              'company_categories:read',
              'company_categories:create',
              'company_categories:update',
              'company_categories:delete',
            ])
          )?_c('IndustryCat',{ref:"industry",attrs:{"status":"Industry"}}):_vm._e(),(
            _vm.hasAccessAll([
              'c4a-default-setumum:read',
              'address_categories:read',
              'address_categories:create',
              'address_categories:update',
              'address_categories:delete',
            ])
          )?_c('AddressCat',{ref:"address",attrs:{"status":"Address"}}):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }